import { useState, useEffect } from "react";
import { warnDev } from "../utils/logger";

function useGeolocation() {
  const [coords, setCoords] = useState(null);
  const [error, setError] = useState(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    if (!navigator.geolocation) {
      setError("Geolocation not supported by your browser.");
      warnDev("Geolocation not supported by your browser.");
      setLoading(false);
      return;
    }

    const primaryOptions = {
      enableHighAccuracy: true,
      timeout: 10000,
      maximumAge: 300000,
    };

    const fallbackOptions = {
      enableHighAccuracy: false,
      timeout: 20000,
      maximumAge: 600000,
    };

    const onSuccess = (pos) => {
      const position = {
        lat: pos.coords.latitude,
        lng: pos.coords.longitude,
      };
      setCoords(position);
      setLoading(false);
    };

    navigator.geolocation.getCurrentPosition(
      onSuccess,
      (err) => {
        // Retry once with relaxed options before surfacing error.
        navigator.geolocation.getCurrentPosition(
          onSuccess,
          (fallbackErr) => {
            setError("Geolocation error: " + fallbackErr.message);
            warnDev("Geolocation error:", fallbackErr.message);
            setLoading(false);
          },
          fallbackOptions
        );
      },
      primaryOptions
    );
  }, []);

  return { coords, error, loading };
}

export default useGeolocation;
